module.exports = __webpack_public_path__ + "static/img/js4.d1306f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js4.png
// module id = z/ao
// module chunks = 1